import moment from 'moment';

export interface DateRangeResult {
  fromKey: string;
  toKey: string;
  fromValue: string | null;
  toValue: string | null;
}

export function processDateRange(
  value: (string | Date)[],
  fromKey: string,
  toKey: string,
  format: string = 'YYYY-MM-DD'
): DateRangeResult {
  const result: DateRangeResult = {
    fromKey,
    toKey,
    fromValue: null,
    toValue: null
  };

  if (Array.isArray(value)) {
    if (value[0]) {
      result.fromValue = moment(value[0]).format(format);
    }
    if (value[1]) {
      result.toValue = moment(value[1]).format(format);
    } else if (value[0]) {
      result.toValue = moment(value[0]).format(format);
    }
  }

  return result;
}
